import React from 'react'
import { useEffect } from 'react';
const FBSDK = (props) => {

    // function statusChangeCallback(response) {  // Called with the results from FB.getLoginStatus().
    //     console.log('statusChangeCallback');
    //     console.log(response);                   // The current login status of the person.
    //     if (response.status === 'connected') {   // Logged into your webpage and Facebook.
    //       testAPI();  
    //     } else {                                 // Not logged into your webpage or we are unable to tell.
    //       document.getElementById('status').innerHTML = 'Please log ' +
    //         'into this webpage.';
    //     }
    // }

    function checkLoginState() {               // Called when a person is finished with the Login Button.
        window.FB.getLoginStatus(function (response) {   // See the onlogin handler
            // statusChangeCallback(response);
        });
    }

    function logout() {
        window.FB.logout(function (response) {
            // user is now logged out
        });
    }
    useEffect(() => {
        testAPI()
    }, [])

    function testAPI() {                      // Testing Graph API after login.  See statusChangeCallback() for when this call is made.
        window.FB.api('/me', function (response) {
            document.getElementById('status').innerHTML =
                'Thanks for logging in, ' + response.name + '!';
        });
    }

    useEffect(() => {
        window.fbAsyncInit = function () {
            window.FB.init({
                appId: '1077052919610339',
                // autoLogAppEvents : true,
                xfbml: true,
                version: 'v15.0'
            });

            // 取得使用者登入狀態
            window.FB.getLoginStatus(function (response) {
                console.log('[refreshLoginStatus]', response);
            });

            window.FB.AppEvents.logPageView();

        };


        const script = document.createElement('script');

        script.src = "https://connect.facebook.net/zh_TW/sdk.js#xfbml=1&version=v15.0";
        script.async = true;
        script.crossOrigin = "anonymous"
        script.nonce = "DFgdOPic"

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        }
    }, []);


    const handleFBLogin = () => {
        // 跳出 Facebook 登入的對話框
        window.FB.login(
            function (response) {
                console.log('handleFBLogin', response);
            },
            { scope: 'public_profile,email' }
        );
    };

    return (
        <div className='w-100 fx-ccc'>
            <div className="fb-login-button"
                onClick={handleFBLogin}
                data-width=""
                data-size="large"
                data-button-type="continue_with"
                data-theme="fill_black"
                data-auto-logout-link="false"
                data-use-continue-as="false">
            </div>
        </div>
    );

}
export default FBSDK;